import React from 'react';
import _ from 'underscore';
import NavigationActionCreator from 'action_creators/navigation';
import PricingActionCreator from 'action_creators/pricing';
import CheckoutPayment from 'views/plugins/checkout/payment';
import AffiliatePaymentSelector from 'views/anyguide/affiliates/components/AffiliatePaymentSelector';
import Discount from 'views/plugins/checkout/discount';
import { t } from 'services/translation';
import { titleize } from 'lib/string_utils';
import CheckoutHeader from '../header';
import Cover from '../cover';
import Submit from '../submit';

class CheckoutPaymentScreen extends React.Component {
  static displayName = 'CheckoutPaymentScreen';

  componentDidMount() {
    // scroll this step to top on mobile views
    window.scrollTo(0, 0);
    // Pre-fill first name and last name from previous screen
    this.props.loadCardHolderInfo();
    if (this.props.shouldShowPayLater) {
      this.props.setInitialPaymentType();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this._hasSaved(prevProps)) {
      NavigationActionCreator.transitionTo(this._nextScreenInfo().screen);
    }
  }

  _hasSaved = (prevProps) => {
    return this.props.saved === true && prevProps.saved === false;
  };

  _nextScreenInfo = () => {
    const baseScreenPath = 'Views.Plugins.Checkout.Mobile.Screens.';
    const baseLabel = `${t('NEXT')}:`;

    if (this.props.shouldShowAdditionalInformation) {
      return {
        screen: `${baseScreenPath}AdditionalInformation`,
        label: `${baseLabel} ${t('ADDITIONAL_INFORMATION')}`,
      };
    }
    return {
      screen: `${baseScreenPath}CheckoutSummary`,
      label: `${baseLabel} ${titleize(t('REVIEW_DETAILS'))}`,
    };
  };

  _googleTagManagerCheckoutProgress = (step) => {
    const {
      total,
      tour_id,
      guests,
      is_ga4_enabled,
      currency,
      unitPriceForInitialPricing,
      totalWithoutServiceFee,
      units_and_addons_detail,
    } = this.props;
    const { name } = this.props.tour;
    try {
      googleTagManagerCheckout(
        {
          tour_id,
          guests,
          name,
          total_price: total,
          is_ga4_enabled,
          currency: currency.toUpperCase(),
          unit_price_for_initial_pricing: unitPriceForInitialPricing,
          total_without_service_fee: totalWithoutServiceFee,
          units_and_addons_detail: units_and_addons_detail.toJS(),
        },
        step
      );
    } catch (error) {
      console.log('google tag error', error);
    }
  };

  _paymentProps = () => {
    return _.extend(
      {},
      _.omit(this.props, [
        'fully_discounted',
        'zero_priced_tour',
        'isPayLaterSelected',
      ]),
      {
        disabled: this.props.total === 0,
        is_booking_invoice: this.props.is_booking_invoice,
        stripeTheme: this.props.stripeTheme,
        googleTagManagerCheckoutProgress:
          this._googleTagManagerCheckoutProgress,
      }
    );
  };

  _coverProps = () => {
    return {
      forInvoice: this.props.forInvoice,
      tourPicture: this.props.tour.picture,
      guideAvatar: this.props.tour.guide_avatar,
      tourName: this.props.tour.name_translation,
      guideName: this.props.tour.guide_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
    };
  };

  render() {
    const {
      timer,
      priceProps,
      selectedPaymentType,
      isPayLaterSelected,
      onSelectPaymentType,
      discount_props,
      onSubmit,
      paymentSubtext,
      shouldShowPayLater,
      isOutsidePayLaterCutoff,
    } = this.props;

    return (
      <div className="CheckoutPaymentScreen">
        <CheckoutHeader priceProps={priceProps} />
        <article className="transition-ctx">
          <Cover {...this._coverProps()} />
          {timer}
          <div className="BookingRequest-form ui form">
            <h2>
              {t('Payment Information')}
              <i className="icon af-lock brand-color" />
            </h2>
            {shouldShowPayLater && (
              <AffiliatePaymentSelector
                paymentType={selectedPaymentType}
                paymentTypeChanged={onSelectPaymentType}
                disabledOptions={!isOutsidePayLaterCutoff ? ['pay-later'] : []}
              />
            )}
            {paymentSubtext}
            {!isPayLaterSelected && (
              <CheckoutPayment {...this._paymentProps()} />
            )}
            {!isPayLaterSelected && <Discount {...discount_props} />}
            <Submit
              label={this._nextScreenInfo().label}
              onSubmit={onSubmit}
              dataTestProp="mobile-review-booking"
            />
          </div>
        </article>
      </div>
    );
  }
}

export default CheckoutPaymentScreen;
